import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadReportCategoryDataUser, saveForumReportUser } from "./Slice/reportUserSlice";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

const ReportUser = (props) => {

  const { userdata } = props;
  const subDomainPath = getSubdomainPath();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [getLoader, setGetLoader] = useState(false);
  const userInfo = useSelector((state) => state?.userInfo || {});
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const { categories } = useSelector((state) => state?.reportUser);

  useEffect(() => {
    dispatch(loadReportCategoryDataUser());
  }, [dispatch]);

  const onSubmit = async (data) => {
    setGetLoader(true);
    const request = {
      category_id: data.category,
      reported_by: userInfo.id,
      reported_to:
        userInfo.role_id == "Mentees"
          ? userdata.item.mentor_id
          : userdata.item.mentee_id,
      description: data.description,
      reported_from: userdata.from,
    };
    try {
      const result = await dispatch(saveForumReportUser(request)).unwrap();
      setPopupMessage(result.message);
      setShowPopup(true);
    } catch (error) {
      setPopupMessage(
        typeof error === "string" ? error : "Something went wrong"
      );
      setShowPopup(true);
    } finally {
      setGetLoader(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="report-modal-header">
          <h3>
            <b>Report User</b>
            <p></p>
            <p>
              {(subDomainPath === "siduat" || subDomainPath === "siddev" || subDomainPath === "sid") ?
                "We will review and take action to remove any objectionable comments/users within 5 working days."
                : "We will review & take action for removing objectionable comments/user within 24 hours"}
            </p>
          </h3>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <div className="form-group mb-3">
                  <label className="form-label" htmlFor="category">Category*</label>
                  <Form.Control
                    as="select"
                    className=""
                    name="category"
                    {...register("category", { required: true })}
                  >
                    <option value="" key="">
                      Select Option
                    </option>
                    {/* {categories && */}
                    {categories.map((item, key) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Control>
                  {errors.category && errors.category?.type === "required" && (
                    <label className="customeValidationText text-left" htmlFor="category">
                      Please select category
                    </label>
                  )}
                </div>
              </Col>
              <Col sm={12}>
                <label className="form-label" htmlFor="description">Reason (Optional)</label>
                <Form.Control
                  as="textarea"
                  className={"form-control"}
                  name="description"
                  defaultValue=""
                  aria-invalid={"false"}
                  {...register("description", { maxLength: 6000 })}
                />
                {errors.description &&
                  errors.description?.type === "maxLength" && (
                    <label className="customeValidationText text-left" htmlFor="description">
                      Description should not more than 6000 characters
                    </label>
                  )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <button
                    className="btn nextbtn btn_red ml-2"
                    type="submit"
                    disabled={getLoader}
                  >
                    {getLoader ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
          props.onHide();
        }}
        message={popupMessage}
        showConfirm={true}   // Make sure OK button exists
        staticBackdrop={true}
      />

    </>
  );
};

ReportUser.propTypes = {
  userdata: PropTypes.shape({
    from: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    mentee_id: PropTypes.string,
    mentor_id: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default ReportUser;
